export default __webpack_public_path__ + "static/hero-7f5495ecfec650e0664466a37a5296f1.png";